export const headers = [

  { field: "id", headerName: "ID", width: 40, hide: true },
  { field: "barrio_descripcion", headerName: "Descripcion", width: 190 },
  { field: "localidad", headerName: "Localidad", width: 190 },
  ];
  